/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseMapStringString } from '../../models/api-response-map-string-string';

export interface GetSignUpGeo$Params {
  'x-api-requestId'?: string;
  'x-api-canal'?: string;
  'X-Forwarded-For'?: string;
}

export function getSignUpGeo(http: HttpClient, rootUrl: string, params?: GetSignUpGeo$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseMapStringString>> {
  const rb = new RequestBuilder(rootUrl, getSignUpGeo.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.header('X-Forwarded-For', params['X-Forwarded-For'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseMapStringString>;
    })
  );
}

getSignUpGeo.PATH = '/v1/api/ui/public/sign-up/geo';
